<template>
    <RegistrationAndLoginSupport></RegistrationAndLoginSupport>
</template>

<script>
    import RegistrationAndLoginSupport from "../components/RegistrationAndLoginSupport";

    export default {
        name: "registration-and-login-support",
        components: {
            RegistrationAndLoginSupport,
        }
    };
</script>